<template>
  <div class="bg-white min-h-screen flex flex-col">
    <TSkipLink />
    <RenderTemplateHeader />

    <main id="main" class="flex-1">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
import { useTemplateDataComposable } from '~~/modules/template/composables/useTemplateDataComposable'

await useTemplateDataComposable({
  template: 'funnel',
})
</script>
